import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProfessionalHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="16601" id="hero" className="px-3 sm:px-4 pt-3 pb-3">
  <div className="mx-auto w-full bg-[#141414] rounded-[1rem] min-h-[70vh] flex flex-col justify-end">
    <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end">
        {/* Left: Heading */}
        <div>
          <span className="mb-5 inline-block rounded-full bg-white/10 border border-white/20 px-5 py-2 text-sm font-semibold uppercase tracking-widest text-white/60">
            Konferenzraum in Kassel-Lohfelden
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight leading-[1.05] text-white">
            Meetings, die funktionieren.
          </h1>
        </div>
        {/* Right: Text */}
        <div>
          <p className="text-lg text-white/60 leading-relaxed">
            Kundenpräsentation. Team-Workshop. Der Pitch, der sitzt. Unser Konferenzraum hat alles, was dein Meeting braucht und nichts, was es stört. Auch ohne Coworking-Vertrag buchbar.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>;
}